export default "__VITE_ASSET__CfjcooQC__"